// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner__LIZOn","lds-ring":"lds-ring__67cyb","turquoise":"turquoise__noWzh"};